import { render } from "./VolTable.vue?vue&type=template&id=157268da"
import script from "./VolTable.vue?vue&type=script&lang=js"
export * from "./VolTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__